import clickOutside from "../helpers/click-outside";
import request from "../helpers/request";

import { createResult, createNoResults } from "../templates/autocomplete";

const autocompleteForm = document.querySelector(".js-autocomplete form");
const autocompleteInput = document.querySelector(".js-autocomplete input");
const autocompleteResults = document.querySelector(".js-autocomplete-results");

let results = [];
let selection = null;

if (autocompleteForm && autocompleteInput) {
    let isActive = false;

    autocompleteForm.addEventListener("submit", (e) => {
        e.preventDefault();
        submit();
    });

    autocompleteInput.addEventListener("focusin", () => {
        isActive = true;
    });

    autocompleteInput.addEventListener("focusout", () => {
        isActive = false;
    });

    autocompleteInput.addEventListener("input", () => {
        search(autocompleteInput.value);
    });

    clickOutside(".js-autocomplete", () => {
        autocompleteResults.classList.remove("c-autocomplete__results--active");
    });

    document.onkeydown = (e) => {
        e = e || window.event;
        if (e.keyCode == "38" && isActive) {
            e.preventDefault();
            toggleActiveRecord(-1);
        } else if (e.keyCode == "40" && isActive) {
            e.preventDefault();
            toggleActiveRecord(1);
        }
    };
}

function search(keywords) {
    if (keywords) {
        request.get(`${SEARCH_API_URL}/autocomplete?keywords=${keywords}`)
            .then(res => {
                clearResults(false);
                if (res.data.length) {
                    results = res.data.map((item, i) => {
                        let element = createResult(keywords, item);

                        autocompleteResults.append(element);

                        element.addEventListener("mouseenter", () => {
                            setActiveRecord(i);
                        });

                        element.addEventListener("click", () => {
                            submit();
                        });

                        return item;
                    });
                    setActiveRecord(0);
                } else {
                    autocompleteResults.append(createNoResults());
                }
            });
    } else {
        clearResults();
    }
}

function submit() {
    if (selection) {
        autocompleteForm.action = selection.url;
        autocompleteForm.submit();
    }
}

function getActiveRecord() {
    return results.indexOf(selection);
}

function setActiveRecord(id) {
    const activeResult = autocompleteResults.childNodes[getActiveRecord()];
    if (activeResult) {
        activeResult.classList.remove("c-autocomplete__result--active");
    }
    autocompleteResults.childNodes[id].classList.add("c-autocomplete__result--active");
    selection = results[id];
}

function toggleActiveRecord(direction) {
    if (results.length) {
        let activeRecord = getActiveRecord();
        if (activeRecord + direction < 0) {
            activeRecord = results.length - 1;
        } else if (activeRecord + direction >= results.length) {
            activeRecord = 0;
        } else {
            activeRecord = activeRecord + direction;
        }
        setActiveRecord(activeRecord);
    }
}

function clearResults(hide) {
    results = [];
    selection = null;
    autocompleteResults.innerHTML = null;
    if (hide === false) {
        autocompleteResults.classList.add("c-autocomplete__results--active");
    } else {
        autocompleteResults.classList.remove("c-autocomplete__results--active");
    }
}